import type { AvatarData } from './schemas';

// Get unique collections from avatars
export const getCollections = (avatars: AvatarData[], override?: string[]): string[] => {
  if (override && override.length > 0) return override;
  const collections = [...new Set(avatars.map(a => a.collection).filter(Boolean) as string[])];
  return collections;
};

// Capitalize first letter
export const capitalize = (str: string): string => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};